<template>
  <el-footer>
    <div style="height:30px">  </div>
    <div  class="footer">ICP：<a href="https://beian.miit.gov.cn/">{{procedureICP}}</a>  Copyright ：{{companyName}}  </div>
  </el-footer>
</template>

<script>
import configJosn from '../../../static/config.json'
export default {
  name: "footTemplate",
  data(){
    return{
      companyName:configJosn.companyName,
      procedureICP:configJosn.procedureICP,
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .footer-wrapper{
    padding:0;
  }
  .footer {
    width:1400px;
    background:#d7cfc7;
    margin-top: -10px;
    margin-left: -20px;
    vertical-align: middle;
    height: 60px;
    line-height:60px;
    font-size: 16px;
    text-align: center;
    color: #333;
  }
</style>



// WEBPACK FOOTER //
// src/view/template/foot.vue